import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('limiting_factors', '/plans/limiting_factors', 'limiting_factors')
const actions = generator.generate()

export default actions
